<template>
  <div id="app">
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{

    }
  },
  methods:{
    isPC(){
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      console.log(flag);
      if(!flag){
        window.location.href = this.$api.base_mobile;
      }
      //return flag;
    },
    isLogin(){
      this.$api.post('/api/user/isLogin',{})
        .then(function(rsp){
          if(rsp.code=="401"){
            localStorage.clear()
          }
        });
    }
  },
  mounted(){
    this.isPC();
    this.isLogin();
  }
}
</script>

<style>
#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*text-align: center;*/
  background-color: #E7EAED;
  height: 100%;
}
html,body{
  height: 100%;
  margin: 0;
  border: 0;
  padding: 0;
}
  a{
    text-decoration: none;
    color: #333333;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue